// Copyright © 2024 Ory Corp
// SPDX-License-Identifier: Apache-2.0
export const registrationUrl = (config) => config.sdk.url + "/self-service/registration/browser";
export const loginUrl = (config) => config.sdk.url + "/self-service/login/browser";
export const settingsUrl = (config) => config.sdk.url + "/self-service/settings/browser";
export const recoveryUrl = (config) => config.sdk.url + "/self-service/recovery/browser";
export const verificationUrl = (config) => config.sdk.url + "/self-service/verification/browser";
